import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

window.addEventListener("error", (event) => {
  if (event.message === "Script error." && event.filename === "") {
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
});

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Register PWA service worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => console.log("SW registered:", reg))
      .catch((err) => console.log("SW failed:", err));
  });
}
